<template>
  <div class="common-layout">
    <el-container style="min-height: 100vh">
      <el-header style="padding: 0">
        <el-affix :offset="0">
          <HeaderModule />
        </el-affix>
      </el-header>
      <el-main
        style="
          padding: 0;
          margin-top: -60px;
          background-color: rgba(245, 247, 250, 0.5);
        "
      >
        <div class="theme">
          <el-text tag="b" class="theme-text theme-title">图库</el-text><br/>
          <el-text tag="b" class="theme-text theme-body">凤凰兮衔图，殷道衰兮周德之符。 ——李白</el-text>
        </div>
        <Waterfall
          :list="photoList"
          :gutter="20"
          :breakpoints="{
            3000: {
              rowPerView: 5,
            },
            1800: {
              rowPerView: 4,
            },
            1200: {
              rowPerView: 3,
            },
            500: {
              rowPerView: 2,
            },
          }"
          style="background: none"
        >
          <template #item="{ item, index }">
            <el-card class="card_img">
              <!-- <LazyImg class="cover" :url="item.url" /> -->
              <div class="demo-image__error">
                <el-image
                  class="pointer"
                  :src="item.url"
                  fit="fill"
                  @click="openImageViewer(index)"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
              </div>
              <div style="text-align: right">
                <el-space wrap :size="size">
                  <el-text size="large" style="color: #4f46e5; font-size: 15px">
                    <el-icon color="#4F46E5">
                      <View />
                    </el-icon>
                    {{ item.review }}
                  </el-text>
                  <el-text
                    class="pointer"
                    size="large"
                    style="color: #4f46e5; font-size: 15px"
                  >
                    <el-icon color="#4F46E5">
                      <Pointer />
                    </el-icon>
                    {{ item.giveALike }}
                  </el-text>
                </el-space>
              </div>
            </el-card>
          </template>
        </Waterfall>
      </el-main>
      <el-footer>
        <FooterModule />
      </el-footer>
    </el-container>
  </div>
  <!-- 图片查看器 -->
  <el-image-viewer
    :url-list="photoList.map((item) => item.url)"
    :initial-index="imageViewerIndex"
    :infinite="infinite"
    :hide-on-click-modal="hideOnClickModal"
    v-if="imageViewerVisible"
    @close="imageViewerVisible = false"
  ></el-image-viewer>
  <BackTop />
  <BackGround style="position: absolute; z-index: -1" />
</template>
    
  <script>
import { Waterfall } from "vue-waterfall-plugin-next";
import { Picture as IconPicture } from "@element-plus/icons-vue";
import "vue-waterfall-plugin-next/dist/style.css";
import { ref } from "vue";
import { onMounted } from "vue";
// import { ElNotification } from "element-plus";
export default {
  components: { Waterfall, IconPicture },
  setup() {
    const imageViewerVisible = ref(false);
    const infinite = ref(false);
    const hideOnClickModal = ref(true);
    const imageViewerIndex = ref(0);
    const size = ref(10);
    const openImageViewer = (index) => {
      imageViewerIndex.value = index;
      imageViewerVisible.value = true;
    };
    let arr = [
      {
        review: 1,
        giveALike: 10,
        url: require("../../assets/img/02.jpg"),
      },
      {
        review: 2,
        giveALike: 10,
        url: require("../../assets/img/01.jpg"),
      },
      {
        review: 2,
        giveALike: 10,
        url: require("../../assets/img/logo.png"),
      },
    ];
    let photoList = ref([
      {
        review: 1,
        giveALike: 10,
        url: "https://img.beiqiai.com/img1.jpg",
      },
      {
        review: 2,
        giveALike: 10,
        url: "https://img.beiqiai.com/img11.jpg",
      },
      {
        review: 3,
        giveALike: 10,
        url: "https://img.beiqiai.com/img3.jpg",
      },
      {
        review: 4,
        giveALike: 10,
        url: "https://img.beiqiai.com/img4.jpg",
      },
      {
        review: 5,
        giveALike: 10,
        url: "https://img.beiqiai.com/img24.jpg",
      },
      {
        review: 6,
        giveALike: 10,
        url: "https://img.beiqiai.com/img6.jpg",
      },
      {
        review: 7,
        giveALike: 10,
        url: "https://img.beiqiai.com/img7.jpg",
      },
      {
        review: 8,
        giveALike: 10,
        url: "https://img.beiqiai.com/img8.jpg",
      },
      {
        review: 9,
        giveALike: 10,
        url: "https://img.beiqiai.com/img9.jpg",
      },
      {
        review: 10,
        giveALike: 10,
        url: "https://img.beiqiai.com/img10.jpg",
      },
      {
        review: 11,
        giveALike: 10,
        url: "https://img.beiqiai.com/img11.jpg",
      },
      {
        review: 12,
        giveALike: 10,
        url: "https://img.beiqiai.com/img12.jpg",
      },
      {
        review: 13,
        giveALike: 10,
        url: "https://img.beiqiai.com/img13.jpg",
      },
      {
        review: 14,
        giveALike: 10,
        url: "https://img.beiqiai.com/img14.jpg",
      },
      {
        review: 15,
        giveALike: 10,
        url: "https://img.beiqiai.com/img15.jpg",
      },
      {
        review: 16,
        giveALike: 10,
        url: "https://img.beiqiai.com/img16.jpg",
      },
      {
        review: 17,
        giveALike: 10,
        url: "https://img.beiqiai.com/img17.jpg",
      },
      {
        review: 18,
        giveALike: 10,
        url: "https://img.beiqiai.com/img18.jpg",
      },
      {
        review: 19,
        giveALike: 10,
        url: "https://img.beiqiai.com/img19.jpg",
      },
      {
        review: 20,
        giveALike: 10,
        url: "https://img.beiqiai.com/img20.jpg",
      },
      {
        review: 21,
        giveALike: 10,
        url: "https://img.beiqiai.com/img21.jpg",
      },
      {
        review: 22,
        giveALike: 10,
        url: "https://img.beiqiai.com/img22.jpg",
      },
      {
        review: 23,
        giveALike: 10,
        url: "https://img.beiqiai.com/img23.jpg",
      },
      {
        review: 24,
        giveALike: 10,
        url: "https://img.beiqiai.com/img24.jpg",
      },
      {
        review: 25,
        giveALike: 10,
        url: "https://img.beiqiai.com/img25.jpg",
      },
    ]);
    const getProduct = () => {
      if (arr.length > 0) {
        photoList.value = [...photoList.value, ...arr];
      } else {
        // ElNotification({
        //   title: "Warning",
        //   message: h('i', { style: 'color: #F56C6C' }, '已经没有图片可以继续加载啦！！！'),
        //   type: "warning",
        //   showClose: false,
        //   duration: 2500
        // });
      }
    };
    const handleScroll = () => {
      const scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      //滚动条滚动距离
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //窗口可视范围高度
      const clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );
      if (clientHeight + scrollTop + 100 >= scrollHeight) {
        //快到底时----加载
        getProduct();
      }
    };
    const debounce = (fn, delay) => {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    };
    onMounted(() => {
      window.addEventListener("scroll", debounce(handleScroll, 1000));
    });
    return {
      photoList,
      imageViewerVisible,
      imageViewerIndex,
      openImageViewer,
      infinite,
      hideOnClickModal,
      size,
    };
  },
};
</script>
    
<style scoped>
.card_img {
  margin-bottom: 7px;
  background: none;
  border-style: none;
}

.demo-image__error .image-slot .el-icon {
  font-size: 200px;
}
/* 隐藏图片查看器的左右切换箭头 */
.el-image-viewer__prev,
.el-image-viewer__next {
  display: none !important;
}

.pointer {
  cursor: pointer;
}

.theme {
  height: 50vh;
  width: 100%;
  background-image: url("../../assets/img/29dcc02e833def4808ddaded64b4e40.jpg"); /* 确保路径正确 */
  background-size: cover; /* 图片将尽可能大地覆盖整个容器，可能会被裁剪 */  
  background-position: center; /* 图片居中显示 */  
  background-repeat: no-repeat; /* 不重复 */  
  display: flex; /* 启用Flexbox布局 */
  justify-content: center; /* 水平居中 */  
  align-items: center; /* 垂直居中 */  
  flex-direction: column; /* 如果需要子元素垂直排列（在这个例子中不是必需的，但可以用于其他布局）*/  
}
.theme h1 {  
  margin: 0; /* 可能需要移除默认的margin来确保更精确的居中 */  
}
@font-face {
  font-family: "MyCustomFont";
  src: url("../../assets/font/luzhongmocaishou.ttf") format("opentype");
}
.theme-text{
  font-family: "MyCustomFont", sans-serif;
  color: #FFFFFF;
  letter-spacing: 4px;
}
.theme-title{
  font-size: 40px;
}
.theme-body{
  font-size: 20px;
}
</style>